import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrown: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="crown, vip"><path d="M4.3125 19.25L1.75 6.75L7.75 10.25L12 3.75L16.25 10.25L22.25 6.75L19.6875 19.25H4.3125Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCrown;
